/**
 * Custom error for not found resources
 */
export class NotFoundError extends Error {
    constructor(resource) {
        super(resource ? `${resource} not found` : 'Resource not found');
        this.name = 'NotFoundError';
    }
}
/**
 * Custom error for database operations
 */
export class DatabaseError extends Error {
    constructor(message, code, details) {
        super(message);
        this.name = 'DatabaseError';
        this.code = code;
        this.details = details;
    }
}
/**
 * Handle Postgrest errors with proper error conversion
 * PGRST116 = Not found (row not found)
 */
export function handlePostgrestError(error) {
    if (error.code === 'PGRST116') {
        throw new NotFoundError();
    }
    throw new DatabaseError(error.message, error.code, error.details);
}
/**
 * Handle Postgrest error and return null for not found
 * Useful for optional queries
 */
export function handlePostgrestErrorOrNull(error, defaultValue = null) {
    if (error.code === 'PGRST116') {
        return defaultValue;
    }
    throw new DatabaseError(error.message, error.code, error.details);
}
